<template>
  <v-container>
    <app-header :buttonAction="action" backButton :backAction="backAction">
      <template #title>{{ data.title }}</template>
      <template v-slot:buttonText>Skip Intro</template>
      <template #extraButton>
        <v-btn
          color="#29284c"
          small
          outlined
          width="120"
          class="text-capitalize mt-2 ml-2"
          @click="$emit('next-step', true)"
          >Skip grammar</v-btn
        >
      </template>
    </app-header>
    <app-video-component v-if="data.lesson_file" class="my-10" :src="data.lesson_file" />
    <app-rich-text class="pt-10" :body="data.rich_text">
      <template v-slot:title>{{ data.rich_title }}</template>
    </app-rich-text>
  </v-container>
</template>
<script>
import VideoComponent from "./../../components/VideoComponent.vue";
import RichText from "./../../components/RichText";
import Header from "./../../components/Header.vue";

export default {
  components: {
    appVideoComponent: VideoComponent,
    appRichText: RichText,
    appHeader: Header,
  },
  props: {
    data: {
      required: false,
      default: () => {},
      type: Object,
    },
  },
  methods: {
    action() {
      this.$emit("next-step");
    },
    backAction() {
      this.$emit("prev-step");
    },
  },
};
</script>
